module.exports = __webpack_public_path__ + "media/images/sharing-150e0f61251716fb3afb4444cc326090.jpg";